export const GET_PROFESSIONAL_SERVICES_DESIGN_SUCCESS = 'GET_PROFESSIONAL_SERVICES_DESIGN_SUCCESS';
export const GET_PROFESSIONAL_SERVICES_DESIGN_FAILURE = 'GET_PROFESSIONAL_SERVICES_DESIGN_FAILURE';
